import React from "react";
import Img from "gatsby-image";

import TagList from "../tag/TagList";
import PostAuthor from "./Author";
import Time from "../time/Time";
import usePost from "../../hooks/usePost";
import { Helmet } from "react-helmet";
import authors from "../../authors.json";

function PostHeader() {
  const {
    heroImage,
    tags,
    categories,
    timeToRead,
    date,
    dateUpdated,
    title,
    author,
  } = usePost();
  const { name } = authors[author];

  return (
    <header className="post__header">
      <Helmet>
        <script type="application/ld+json">
          {`
                {
                    "@context": "https://schema.org",
                    "@type": "Article",
                    "headline": "${title}",
                    "image": [
                    "https://accesto.com${heroImage.childImageSharp.fluid.src}"
                    ],
                    "datePublished": "${date}",
                    "dateModified": "${dateUpdated ? dateUpdated : date}",
                    "author": [{
                        "@type": "Person",
                        "name": "${name}"
                    }]
                }
            `}
        </script>
      </Helmet>
      <div className="post__imageContainer">
        <Img
          fluid={heroImage.childImageSharp.fluid}
          title={title}
          alt={title}
        />
        <div className="post__overlay"></div>
      </div>

      <TagList className="post__tagList" categories={categories} tags={tags} />
      <Time
        className="post__time"
        timeToRead={timeToRead}
        date={date}
        dateUpdated={dateUpdated}
      />
      <h1 className="h1 post__heading">{title}</h1>

      <PostAuthor />
    </header>
  );
}

export default PostHeader;
